/*** IMPORTS FROM imports-loader ***/
var fetchPolyfill = require("polyfills/fetch");
var classListPolyfill = require("polyfills/classList");

/** @module components/callouts/save-for-later-callout-prompt */
import baustein from "baustein";
import SaveForLaterCallout from "./save-for-later-callout";

/**
 * Shows the save-for-later callout.
 *
 * @constructor
 * @alias module:components/callouts/save-for-later-callout-prompt
 * @extends module:baustein
 */
export default baustein.register(
    "save-for-later-callout-prompt",
    /** @lends module:components/callouts/save-for-later-callout-prompt.prototype */
    {
        defaultOptions: {
            next: "/"
        },

        showSaveForLaterCallout() {
            let callout = this.findComponent("save-for-later-callout");

            if (callout) {
                callout.destroy();
            }

            callout = new SaveForLaterCallout({ next: this.options.next });
            callout.appendTo(this.el);
        }
    }
);

